import {Pipe, PipeTransform} from '@angular/core';
import {Task} from "../api";
import LphEnum = Task.LphEnum;

/**
 * Transforms LPH Enum Value to String
 */
@Pipe({name: 'lph'})
export class LphPipe implements PipeTransform {

    /**
     * Transform Enum Value to String
     * @param value LPphEnum Value or numeric LPH value (1-9)
     */
    transform(value: LphEnum | number | string | undefined): string {
        switch (value) {
            case "LPH1":
          case 1:
                return "1"
            case "LPH2":
          case 2:
                return "2"
            case "LPH3":
          case 3:
                return "3"
            case "LPH4":
          case 4:
                return "4"
            case "LPH5":
          case 5:
                return "5"
            case "LPH6":
          case 6:
                return "6"
            case "LPH7":
          case 7:
                return "7"
            case "LPH8":
          case 8:
                return "8"
            case "LPH9":
          case 9:
                return "9"
            default:
                return ""
        }
    }
}


@Pipe({
    name: 'lphName',

})
export class LphNamePipe implements PipeTransform {
  transform(value: LphEnum | number | string | undefined): string {
    switch (value) {
      case "LPH1":
      case 1:
        return "Grundlagenermittlung"
      case "LPH2":
      case 2:
        return "Vorplanung"
      case "LPH3":
      case 3:
        return "Entwurfsplanung"
      case "LPH4":
      case 4:
        return "Genehmigungsplanung"
      case "LPH5":
      case 5:
        return "Ausführungsplanung"
      case "LPH6":
      case 6:
        return "Vorbereitung der Vergabe"
      case "LPH7":
      case 7:
        return "Mitwirkung bei der Vergabe"
      case "LPH8":
      case 8:
        return "Objektüberwachung"
      case "LPH9":
      case 9:
        return "Objektbetreuung und Dokumentation"
      default:
        return ""
    }
  }
}
